import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class BannarService {

  baseUrl = environment.baseUrl;
  bannarImagePreview: string | ArrayBuffer | null = null;
  

  bannar_form = new FormGroup({
    id: new FormControl(null),
    name: new FormControl('', [Validators.required]),
    image_path: new FormControl(null),
    image_type: new FormControl('', [Validators.required]),
    page_key: new FormControl('', [Validators.required])
  });

  constructor(private http: HttpClient,
    private loading: LoadingService,) { }

  populateForm(bannarData: any) {
    //console.log(bannarData);
    this.bannar_form.setValue(_.omit(bannarData, 'is_active', 'sort_order', 'created_at', 'updated_at', 'deleted_at'));
    // this.bannar_form.patchValue({ image_path: bannarData.bannar_img });
    this.bannarImagePreview = bannarData.image_path;
  }

  get_bannars() {
    // console.log(this.baseUrl + '/images');
    return this.http.get(this.baseUrl + '/images');
  }

  /* Insert Bannar */
  insert_bannar(formData: any, bannar_img: any) {
    // console.log(bannar_img);
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('name', formData.name);
    myFormData.append('image', bannar_img);
    myFormData.append('image_type', formData.image_type);
    myFormData.append('page_key', formData.page_key);
    // console.log(myFormData);
    return this.http.post(this.baseUrl + '/images', myFormData, {
      headers: headers
    });
  }
  

  // get_bannar_id(bannar_id) {
  //   return this.http.get(this.baseUrl + '/get_bannar_id/' + bannar_id);
  // }


  /* Update Bannar */
  update_bannar(formData: any, bannar_img: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('name', formData.name);
    myFormData.append('image', bannar_img);
    myFormData.append('image_type', formData.image_type);
    myFormData.append('page_key', formData.page_key);
    console.log(myFormData);
    return this.http.post(this.baseUrl + '/images/' + formData.id, myFormData, {
      headers: headers
    });
  }


  delete_bannar(id: any) {
    return this.http.delete(this.baseUrl + '/images/' + id);
  }


}
